'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _log = require('./log');

var _log2 = _interopRequireDefault(_log);

var _assert = require('./assert');

var assert = _interopRequireWildcard(_assert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_RELEASE_DELAY = 2000;
var UID_PREFIX = 'ReferenceCounter_';
var id = 0;

_log2.default.disableAll();

var ReferenceCounter = function () {
    /**
     *
     * @param {object} value
     * @param {function?} releaseCallback
     */
    function ReferenceCounter(value, releaseCallback) {
        _classCallCheck(this, ReferenceCounter);

        this._value = value;
        this._references = 0;
        this._releaseCallback = releaseCallback;
        this._uid = '' + UID_PREFIX + id++;
        this._destroyed = false;
    }

    _createClass(ReferenceCounter, [{
        key: 'retain',
        value: function retain() {
            assert.checkState(!this._destroyed, 'can\'t retain destroyed ' + this);

            this._references = this._references + 1;
            _log2.default.trace('retain ' + this);
            return this._value;
        }

        /**
         *
         * @param {number?} delay
         */

    }, {
        key: 'releaseWithDelay',
        value: function releaseWithDelay() {
            var _this = this;

            var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_RELEASE_DELAY;

            assert.checkState(this._references > 0, 'can\'t release ' + this);

            setTimeout(function () {
                return _this.release();
            }, delay);
        }
    }, {
        key: 'release',
        value: function release() {
            assert.checkState(this._references > 0, 'can\'t release ' + this);

            this._references = this._references - 1;

            _log2.default.trace('release ' + this);

            if (this._references === 0) {
                this._destroyed = true;
                if (this._releaseCallback) {
                    this._releaseCallback(this._value);
                }
            }
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            return this._value;
        }
    }, {
        key: 'toString',
        value: function toString() {
            return 'RefCounter(' + this._uid + ', ref = ' + this._references + ', value = ' + this._value.toString() + ')';
        }
    }]);

    return ReferenceCounter;
}();

exports.default = ReferenceCounter;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/aurora-javascript-utils/dist/ReferenceCounter.js
// module id = 1352
// module chunks = 118